/* angular:styles/component:css;780f8f3e339aa0bcb775c5a8f9b21c67b5e5db613a93300904b911430ffbd036;C:\project\2026\patient\termed-app\src\components\common\country-selector-popover.component.ts */
.title {
  font-size: 16px;
  font-weight: 800;
}
.country-flag {
  font-size: 24px;
  display: block;
  text-align: center;
}
ion-toolbar {
  --min-height: 40px;
}
.search-bar {
  --padding-start: 12px;
  --padding-end: 12px;
  --padding-top: 5px;
  --padding-bottom: 10px;
}
.flag-container {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.flag-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.flag-container .flag-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
}
.hidden {
  display: none;
}
ion-item {
  --padding-start: 12px;
  --padding-end: 12px;
  --padding-top: 0;
  --margin-top: 0;
}
ion-content {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
}
/*# sourceMappingURL=browser/country-selector-popover.component.css.map */
